import { ActionsList } from "@/Actions/components/ActionsList";

/** The Action Hub tab: actions published by Roboto and other orgs. */
export function ActionHub() {
  return <ActionsList scope="actionhub" />;
}
